var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCustomerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 52,
    viewBox: "0 0 72 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1777 29.6725C55.6302 32.695 58.7502 36.79 58.7502 42.25V52H71.7502V42.25C71.7502 35.165 60.1477 30.9725 51.1777 29.6725Z",
    fill: "#F4F9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7502 26C52.9327 26 58.7502 20.1825 58.7502 13C58.7502 5.8175 52.9327 0 45.7502 0C44.2227 0 42.7927 0.324999 41.4277 0.779999C44.1252 4.1275 45.7502 8.385 45.7502 13C45.7502 17.615 44.1252 21.8725 41.4277 25.22C42.7927 25.675 44.2227 26 45.7502 26Z",
    fill: "#F4F9FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 26C33.4325 26 39.25 20.1825 39.25 13C39.25 5.8175 33.4325 0 26.25 0C19.0675 0 13.25 5.8175 13.25 13C13.25 20.1825 19.0675 26 26.25 26ZM26.25 6.5C29.825 6.5 32.75 9.425 32.75 13C32.75 16.575 29.825 19.5 26.25 19.5C22.675 19.5 19.75 16.575 19.75 13C19.75 9.425 22.675 6.5 26.25 6.5Z",
    fill: "#F4F9FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 29.25C17.5725 29.25 0.25 33.605 0.25 42.25V52H52.25V42.25C52.25 33.605 34.9275 29.25 26.25 29.25ZM45.75 45.5H6.75V42.2825C7.4 39.9425 17.475 35.75 26.25 35.75C35.025 35.75 45.1 39.9425 45.75 42.25V45.5Z",
    fill: "#F4F9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCustomerIcon);
export default __webpack_public_path__ + "static/media/white-customer-icon.f8502014622ab09f82320b843a9f9658.svg";
export { ForwardRef as ReactComponent };